// The “Today” tab of a public figure’s profile (15 October 2026).
export default {
  aucune: 'No listening delivered yet: this tab fills in after the next listening.',
  quand: { aujourdhui: 'today', hier: 'yesterday' },
  chiffres: {
    aria: 'The figures of the day',
    note: {
      titre: 'Score',
      unite: 'out of 100',
      ecart: '{n} over 7 days',
      sansRecul: 'less than a week of listening',
    },
    volume: {
      titre: 'How much it is talked about',
      valeur: '×{v}',
      unite: 'the usual',
      vide: 'no usual level yet',
      attente: 'a few more days of listening',
      record: 'the highest in the last 30 days',
      dessus: 'above the usual',
      dessous: 'below the usual',
      habituel: 'within the usual',
    },
    part: {
      titre: 'Share of voice',
      unite: '% of your follows',
      vide: 'not measured that day',
      ecart: '{n} points since the day before',
      stable: 'same as the day before',
      sansVeille: 'nothing to compare the day before',
    },
    publications: {
      titre: 'Own posts',
      uniteMultiple: 'their usual reactions',
      unite: '% reactions',
      vide: 'no post',
      ceJour: 'that day',
      nombre: 'post | post | posts',
      sansHabitude: 'no usual level to compare yet',
      dessus: 'above the usual',
      dessous: 'below the usual',
      habituel: 'within the usual',
    },
  },
  journee: {
    titre: 'What made the day',
    jour: '{jour}',
    sansResume: 'No summary for that day.',
    peuDeMatiere: 'little material that day',
    sens: '({sens})',
  },
  courbe: {
    titre: 'Score and how much it is talked about, over 30 days',
    note: 'the score',
    volume: 'the volume, against the usual',
    neutre: 'the dotted line: 50, neutral',
    aujourdhui: 'today',
    aria: 'Score over 30 days: {debut} on the first day, {fin} on the last',
  },
  citations: {
    titre: 'Quotes of the day',
    toutes: 'All quotes',
    aucune: 'No quote captured in the last few days.',
  },
  alertes: {
    titre: 'Alerts of the day',
    nouvelle: 'New',
    aucune: 'No alert in the last two days.',
    personas: 'See who is talking',
    positions: 'See the positions',
  },
  plateformes: {
    titre: 'Where it is talked about',
    aucune: 'Nothing captured that day.',
    pct: '{n}%',
    moinsDeUn: '< 1%',
  },
  publications: {
    titre: 'Own posts',
    aucune: 'No post that day.',
    sansHabitude: '{n} post that day; not enough history yet to compare it with the usual. | {n} post that day; not enough history yet to compare it with the usual. | {n} posts that day; not enough history yet to compare them with the usual.',
    dessus: '{n} post that day, with {r}% more reactions than usual. | {n} post that day, with {r}% more reactions than usual. | {n} posts that day, with {r}% more reactions than usual.',
    dessous: '{n} post that day, with {r}% fewer reactions than usual. | {n} post that day, with {r}% fewer reactions than usual. | {n} posts that day, with {r}% fewer reactions than usual.',
    multiple: '{n} post that day, with {x} times their usual reactions. | {n} post that day, with {x} times their usual reactions. | {n} posts that day, with {x} times their usual reactions.',
    habituel: '{n} post that day, in line with the usual reactions. | {n} post that day, in line with the usual reactions. | {n} posts that day, in line with the usual reactions.',
  },
  // The sentiment barometer (16 October 2026).
  barometre: {
    titre: 'Sentiment barometer',
    lisse: 'what is said, smoothed over three days',
    sens: { favorable: 'Favourable', neutre: 'Neutral', defavorable: 'Unfavourable' },
    pct: '{n}%',
    points: '{n} pts over 7 days',
    stable: 'stable over 7 days',
    solde: 'Balance: {n} (favourable minus unfavourable)',
    barreAria: '{f}% favourable, {n}% neutral, {d}% unfavourable',
    colonne: '{jour}: {f}% favourable, {n}% neutral, {d}% unfavourable',
    colonneVide: '{jour}: nothing read that day',
    vide: 'empty slot: a day with nothing to read',
  },
}
